import HeroSection from "@/components/bootcamp-landing/HeroSection";
import ProgramCarousel from "@/components/bootcamp-landing/ProgramCarousel";
import ProcedureSteps from "@/components/common/procedure-steps/ProcedureSteps";
import RequirementsSection from "@/components/bootcamp-landing/RequirementSection";
import { WithDefaultLayout } from "@/components/DefautLayout";
import { Page } from "@/types/Page";
import { procedure_steps } from "@/constants";
import { Title } from "@/components/Title";
import ProfileTrainer from "@/components/workshop-landing/ProfileTrainer";

const BootcampPage: Page = () => {
  return (
    <>
      <Title title={"Bootcamp"} description="" />
      <div className="flex flex-col gap-10">
        <HeroSection />
        <ProgramCarousel />
        <ProfileTrainer />
        <RequirementsSection />
        <ProcedureSteps
          title="Prosedur Pendaftaran"
          subtitle=""
          steps={procedure_steps}
        />
      </div>
    </>
  );
};

BootcampPage.layout = WithDefaultLayout;
export default BootcampPage;
